document.addEventListener("DOMContentLoaded", function(){

/* --------------------------
LOAD WISHLIST
-------------------------- */

let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];


/* --------------------------
SAVE WISHLIST
-------------------------- */

function saveWishlist(){
localStorage.setItem("wishlist", JSON.stringify(wishlist));
updateIcons();
updateCounter();
}


/* --------------------------
UPDATE HEART ICONS
-------------------------- */

function updateIcons(){

document.querySelectorAll(".wishlist-icon").forEach(icon=>{

let handle = icon.dataset.productHandle;
if(!handle) return;

if(wishlist.includes(handle)){
icon.classList.add("active");
}else{
icon.classList.remove("active");
}

});

}


/* --------------------------
HEADER COUNTER
-------------------------- */

function updateCounter(){

let count = wishlist.length;

document.querySelectorAll(".wishlist-count").forEach(el=>{

if(count > 0){
el.style.display = "flex";
el.textContent = count;
}else{
el.style.display = "none";
}

});

let headerHeart = document.querySelector(".wishlist-header-icon");

if(headerHeart){

if(count > 0){
headerHeart.classList.add("active");
}else{
headerHeart.classList.remove("active");
}

}

}


/* --------------------------
TOGGLE WISHLIST (FINAL FIX)
-------------------------- */

document.addEventListener("click", function(e) {

  const btn = e.target.closest(".wishlist-icon");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();


  const handle = btn.dataset.productHandle;
  if (!handle) return;

  if (wishlist.includes(handle)) {
    wishlist = wishlist.filter(item => item !== handle);
    showPopup("Removed from wishlist");
  } else {
    wishlist.push(handle);
    showPopup("Added to wishlist ❤️");
  }

  saveWishlist();

});



/* --------------------------
REMOVE FROM PAGE
-------------------------- */

document.body.addEventListener("click",function(e){

let removeBtn = e.target.closest(".wishlist-remove");
if(!removeBtn) return;

let handle = removeBtn.dataset.handle;

wishlist = wishlist.filter(item => item !== handle);

saveWishlist();
renderWishlist();

showPopup("Removed from wishlist");

});


/* --------------------------
ADD TO CART
-------------------------- */

document.body.addEventListener("click",function(e){

let btn = e.target.closest(".add-to-cart");
if(!btn) return;

let id = btn.dataset.id;

fetch("/cart/add.js",{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({
id:id,
quantity:1
})
})
.then(()=>{

showPopup("Added to cart");

});

});


/* --------------------------
POPUP
-------------------------- */

function showPopup(text){

let popup = document.createElement("div");

popup.className = "wishlist-popup";
popup.innerText = text;

document.body.appendChild(popup);

setTimeout(()=>{
popup.classList.add("show");
},10);

setTimeout(()=>{
popup.remove();
},2500);

}


/* --------------------------
RENDER WISHLIST PAGE
-------------------------- */

function renderWishlist(){

let container = document.querySelector("#wishlist-products");
if(!container) return;

container.innerHTML = "";

/* EMPTY STATE */

if(wishlist.length === 0){

container.innerHTML = `
<div class="wishlist-empty">
Your wishlist is empty<br><br>
<a href="/collections/all">Continue Shopping</a>
</div>
`;

return;

}

/* LOAD PRODUCTS */

wishlist.forEach((handle)=>{

fetch(`/products/${handle}.js`)
.then(res => {

if(!res.ok){
console.warn("Wishlist product not found:", handle);
return null;
}

return res.json();

})
.then(product => {

if(!product) return;

/* IMAGE FIX */

let image = product.featured_image || product.images[0] || "";

if(image.startsWith("//")){
image = "https:" + image;
}

/* PRICE */

let price = "₹" + (product.price / 100).toLocaleString();

/* CARD */

let html = `
<div class="wishlist-card">

<a href="/products/${product.handle}">
<img src="${image}" alt="${product.title}">
</a>

<h3>${product.title}</h3>

<p>${price}</p>

<div class="wishlist-card-actions">

<button class="add-to-cart"
data-id="${product.variants[0].id}">
Add to Cart
</button>

<button class="wishlist-remove"
data-handle="${product.handle}">
Remove
</button>

</div>

</div>
`;

container.insertAdjacentHTML("beforeend", html);

})
.catch(err=>{
console.error("Wishlist error:", err);
});

});

}

/* SHARE WISHLIST */

let shareBtn = document.querySelector(".wishlist-share");

if(shareBtn){

shareBtn.addEventListener("click",function(){

let url = window.location.href;

if(navigator.share){

navigator.share({
title:"My Wishlist",
text:"Check out my wishlist",
url:url
});

}else{

navigator.clipboard.writeText(url);
alert("Wishlist link copied");

}

});

}


/* --------------------------
INIT
-------------------------- */

updateIcons();
updateCounter();

if(document.querySelector("#wishlist-products")){
renderWishlist();
}

});

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".wishlist-icon");

  // Load saved wishlist from localStorage
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  buttons.forEach((btn) => {
    const productId = btn.dataset.productId;

    // Set active state on load
    if (wishlist.includes(productId)) {
      btn.classList.add("active");
    }

    // Click handler
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      if (wishlist.includes(productId)) {
        wishlist = wishlist.filter(id => id !== productId);
        btn.classList.remove("active");
      } else {
        wishlist.push(productId);
        btn.classList.add("active");
      }

      localStorage.setItem("wishlist", JSON.stringify(wishlist));
    });
  });
});